var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { "content-class": "no-overflow-x", bus: _vm.busModal },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                { attrs: { primary: "" }, on: { click: _vm.selecionar } },
                [_vm._v(" Selecionar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        [
          _c("Title", { attrs: { title: _vm.title, subtitle: _vm.subtitle } }),
          _c(
            "v-row",
            { staticClass: "justify-content-center" },
            [
              _c("v-col", { attrs: { cols: "8" } }, [
                _vm.clientes.length > 0
                  ? _c(
                      "div",
                      [
                        _c("v-autocomplete", {
                          ref: "campo",
                          staticClass:
                            "short-search align-icon-search no-border",
                          staticStyle: { "max-width": "300px" },
                          attrs: {
                            items: _vm.clientes,
                            filled: "",
                            "item-value": "id",
                            "item-text": "name",
                            label: "",
                            autocomplete: "off",
                            "return-object": "",
                            "full-width": "",
                            autofocus: "",
                            placeholder: "Pesquisar outro cliente",
                            filter: _vm.customFilter,
                            dense: "",
                            "hide-details": ""
                          },
                          on: { change: _vm.search },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticStyle: {
                                          color: "inherit",
                                          "margin-top": "-2px"
                                        }
                                      },
                                      [_vm._v(" mdi-magnify ")]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      {
                                        staticStyle: { display: "table-column" }
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "align-items": "center"
                                            }
                                          },
                                          [
                                            !item.id_cadastro_cliente
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      right: "",
                                                      color: "primary"
                                                    }
                                                  },
                                                  [_vm._v(" mdi-account ")]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      right: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " mdi-account-switch "
                                                    )
                                                  ]
                                                ),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "0px",
                                                  "margin-left": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c("v-row", [
                                          _c(
                                            "small",
                                            {
                                              staticClass: "text-secondary",
                                              staticStyle: {
                                                "margin-left": "15px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.emailDoCliente(item)
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2918899163
                          ),
                          model: {
                            value: _vm.client,
                            callback: function($$v) {
                              _vm.client = $$v
                            },
                            expression: "client"
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "align-items-center justify-content-center d-flex",
                        staticStyle: { "flex-direction": "column" }
                      },
                      [
                        _c("p", [_vm._v(" Nenhum cliente encontrado ")]),
                        _c(
                          "BaseButton",
                          {
                            attrs: { primary: "" },
                            on: { click: _vm.openNewClient }
                          },
                          [_c("strong", [_vm._v("+")]), _vm._v(" Cliente ")]
                        )
                      ],
                      1
                    )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }